export const campaignTypes = [
   { label: "Single Access", value: "single_access" },
   { label: "Multiple Access", value: "multiple_access" },
];

export const productTypes = [
   { label: "SaaS", value: "saas" },
   { label: "E-Commerce", value: "e-commerce" },
];

export const interval = [
   { label: "Daily", value: "daily" },
   { label: "Weekly", value: "weekly" },
   { label: "Monthly", value: "monthly" },
   { label: "Anually", value: "Anually" },
];

export const commissionTypes = [
   { label: "Fixed", value: "fixed" },
   { label: "Percentage", value: "percentage" },
];

export const payoutFrequencies = [
   { label: "15th", value: "NET15" },
   { label: "20th", value: "NET20" },
   { label: "30th", value: "NET30" },
];
